const reconciliationEndpoints = {
  list: (groupCompanyId: string) => `/finadeck/reconciliation/G${groupCompanyId}` as const,
  approvals: (groupCompanyId: string) => `/finadeck/reconciliation/G${groupCompanyId}/approvals` as const
}

export default reconciliationEndpoints
